<div class="quote mat-display-1">As deposit growth slows down in the U.S., the new FDIC guidance is opening the door to technology platform sourced, non-brokered deposits for both banks and large depositors.</div>
<div class="mat-caption">ANTHONY J. CARFANG, MANAGING DIRECTOR - THE CARFANG GROUP</div>
